import { Box } from "@mui/material";
import React, { useState } from "react";
import { additionalInfo, registerStepTwoHeader, submit } from "./messages";
import { useFormik } from "formik";
import SelectCountryDropdown from "./SelectCountryDropdown";
import { object, string, bool } from "yup";
import Button from "./button/Button";
import Text from "./text/Text";
import {
  authOptionsFooterDivider,
  callAPIInterface,
  getDefaultCurrencyBasedOnCountry,
} from "./constants";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setWalletCurrency } from "../redux/actions";
import { sessionService } from "redux-react-session";
import SelectStateDropdown from "./SelectStateDropdown";
import ApplyPromoCode from "./ApplyPromoCode";

const AddCountry = ({ isFromBrowser }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState();
  let walletAccounts = location?.state?.walletAccounts;

  const validationSchema = object({
    country: string().required(),
    state: string().when("statesAvailable", {
      is: true,
      then: () => string().required(),
    }),
    referralCode: string(),
    promoCode: string(),
    statesAvailable: bool(),
  });

  const handleRegister = async (val) => {
    const data = {
      ...(!walletAccounts[0]?.account?.country && { country: val?.country }),
      state: val?.state || undefined,
      referral_code: val?.referralCode || undefined,
      promo_code: val?.promoCode || undefined,
    };
    try {
      setIsLoading(true);
      const response = await callAPIInterface(
        "PUT",
        "/account",
        JSON.stringify(data)
      );

      walletAccounts[0].account.country = response?.country;
      walletAccounts[0].account.state = response?.state;

      const currentSession = await sessionService.loadSession();

      await sessionService.saveSession({
        ...currentSession,
        account: walletAccounts[0],
      });

      dispatch(
        setWalletCurrency(getDefaultCurrencyBasedOnCountry(walletAccounts))
      );
      navigate("/dashboard");
    } catch (error) {
      navigate("/");
    } finally {
      localStorage.removeItem("referralCode");
      setIsLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      country: walletAccounts[0]?.account?.country || null,
      state: null,
      referralCode: "",
      promoCode: "",
      statesAvailable: false,
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: handleRegister,
  });

  const { isValid, dirty, handleSubmit } = formik;

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Box
        className="add-country-container"
        m={!isFromBrowser ? "0px 20px" : "0"}
      >
        {isFromBrowser && (
          <Text className="default-text" size={18} font="bold">
            {registerStepTwoHeader}
          </Text>
        )}
        <Text
          className="grey-text"
          size={14}
          font="regular"
          sx={{ marginTop: "20px" }}
        >
          {additionalInfo}
        </Text>
        <SelectCountryDropdown
          formik={formik}
          customClass="add-country-input"
          countryFromResponse={walletAccounts[0]?.account?.country}
        />
        <SelectStateDropdown formik={formik} customClass="add-country-input" />
        {/* {!walletAccounts[0]?.account?.country && (
          <ApplyPromoCode formik={formik} isFromBrowser={isFromBrowser} />
        )} */}
      </Box>
      {isFromBrowser && authOptionsFooterDivider}
      <Box className={!isFromBrowser ? "footer" : ""}>
        <Button
          type="submit"
          sx={!isFromBrowser && { m: "14px 20px" }}
          disabled={!(isValid && dirty)}
          fullWidth
          variant="contained"
          label={submit}
          loading={isLoading}
        />
      </Box>
    </Box>
  );
};

export default AddCountry;
